import ES_template from './JobDetail/es';
import UK_template from './JobDetail/uk';
import FR_template from './JobDetail/fr';
import EU_template from './JobDetail/eu';
import ES_SO_template from './ShipperOrderDetail/es';
import UK_SO_template from './ShipperOrderDetail/uk';
import FR_SO_template from './ShipperOrderDetail/fr';
import EU_SO_template from './ShipperOrderDetail/eu';
import ES_Assignation_template from './AssignationDetail/es';
import UK_Assignation_template from './AssignationDetail/uk';
import FR_Assignation_template from './AssignationDetail/fr';
import EU_Assignation_template from './AssignationDetail/eu';

const copyTemplates = {
  journey: {
    ES: ES_template,
    UK: UK_template,
    FR: FR_template,
    EU: EU_template,
    NL: UK_template,
  },
  shipperOrder: {
    ES: ES_SO_template,
    UK: UK_SO_template,
    FR: FR_SO_template,
    EU: EU_SO_template,
    NL: UK_SO_template,
  },
  assigned: {
    ES: ES_Assignation_template,
    UK: UK_Assignation_template,
    FR: FR_Assignation_template,
    EU: EU_Assignation_template,
    NL: UK_Assignation_template,
  },
};

const jobText = (item, offerLink) =>
  copyTemplates.journey[(item || {}).country_code](item, offerLink);
const assignedJobText = (item) => copyTemplates.assigned[(item || {}).country_code](item);
const shipperOrderText = (item) => {
  const { data } = item;
  const { route } = data;
  const { country } = route || {};

  return copyTemplates.shipperOrder[country](item);
};

const templates = {
  jobDetail: jobText,
  assignation: assignedJobText,
  shipperOrder: shipperOrderText,
};

export default templates;
